export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || 'dev-ss672tpt2sq2sqp8.us.auth0.com',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || 'Nu16i935YjRdKb1J8zfnf10sZaMeZldy', // Frontend SPA client
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || 'https://api.fitmanager.com',
  authorizationParams: {
    redirect_uri: window.location.origin + '/callback',
    audience: import.meta.env.VITE_AUTH0_AUDIENCE || 'https://api.fitmanager.com',
    scope: 'openid profile email read:users write:users read:clients write:clients read:coaches write:coaches read:exercises write:exercises read:programs write:programs read:sessions write:sessions',
  },
};

export const apiConfig = {
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://fit-backend-web.fly.dev',
  timeout: 60000, // Increased to 60 seconds for long-running operations like program generation
};
